Ext.define('SA.EditCrosstabAttributesRequiredRule', {
    constructor(model) {
        this.model = model;
    },

    getMessage() {
        return 'Please select at least one row data variable and one column data variable.';
    },

    isBroken() {
        return this.model.needsAttributes();
    }
});